import React from 'react';
import {Composition} from 'remotion';
import {PeaklamenClip} from './Video.jsx';

const clips = [
  ['score-meter', 'score'],
  ['grant-rejections', 'rejections'],
  ['funder-checklist', 'checklist'],
  ['audit-review-compilation', 'assurance'],
  ['board-size', 'board'],
  ['first-grant', 'timeline'],
];

export const RemotionRoot = () => (
  <>
    {clips.map(([id, scene]) => (
      <Composition
        key={id}
        id={id}
        component={PeaklamenClip}
        durationInFrames={480}
        fps={24}
        width={960}
        height={540}
        defaultProps={{scene}}
      />
    ))}
  </>
);
